import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import s from './LoginPageStyleFooter.module.scss';
import verbundLogo from '../../assets/images/verbund_logo.svg';
import GlobalContext from '../GlobalContext';

/**
 * Login page style footer
 * renders footer with logo copyright and links
 */
function LoginPageStyleFooter(props) {
  const date = new Date();
  const year = date.getFullYear();
  const copyrightMessage = '© VERBUND Energy4Business GmbH';

  const { links, fixed } = props;
  const localeContext = useContext(GlobalContext);
  const locale = localeContext.locale ?? 'de';

  return (
    <div
      className={`${s.loginFooterContainer} ${fixed ? s.fixed : s.notFixed}`}
    >
      <div className={s.loginLeftContainer}>
        <div className={s.loginVerbundLogo}>
          <img src={verbundLogo} alt="Logo - Verbund" />
        </div>
        <span className={s.loginCopyright}>
          {copyrightMessage} {year}
        </span>
      </div>
      <div className={s.loginCenterContainer}>
        <span className={s.loginCopyright}>
          {copyrightMessage} {year}
        </span>
      </div>
      <div className={s.loginRightContainer}>
        {links.map((link) => (
          <a
            key={link.i18n}
            className="link"
            id={`__test-link_${link.i18n}`}
            href={link[locale]}
          >
            <FormattedMessage id={link.i18n} />
          </a>
        ))}
      </div>
    </div>
  );
}

LoginPageStyleFooter.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      de: PropTypes.string.isRequired,
      en: PropTypes.string.isRequired,
      i18n: PropTypes.string.isRequired,
    })
  ).isRequired,
  fixed: PropTypes.bool.isRequired,
};

export default LoginPageStyleFooter;
